import React from 'react';
import { SectionShell } from './SectionShell';
import { contextParagraphs } from '../data/caseStudy';
export function ContextSection() {
  return <SectionShell number="01" title="Context" tone="light" data-id="element-36" data-mp="13x7mz5jktoeq">
      <div className="grid grid-cols-12 gap-16" data-id="element-37" data-mp="1hp4d541opo8h">
        <div className="col-span-7 space-y-8" data-id="element-38" data-mp="1hqp4kkspcr24">
          {contextParagraphs.map(paragraph => <p key={paragraph.slice(0, 24)} className="text-lg leading-[1.75] text-ink/80" data-id="element-39" data-mp="1dpn2lw7ei0wg">
              {paragraph}
            </p>)}
          <div className="border-l-2 border-accent-purple pl-8" data-id="element-40" data-mp="kzdcso6pp6ur">
            <h3 className="font-display text-[11px] font-semibold uppercase tracking-[0.18em] text-accent-purple" data-id="element-41" data-mp="yyd5q819c7wq">
              The business need
            </h3>
            <p className="mt-4 text-lg leading-[1.75] text-ink/80" data-id="element-42" data-mp="txyukh4d0huh">
              I moved into the Creative Lead role and took full ownership of the rebrand and everything the brand touched internally and externally. This wasn’t a rebrand in the traditional sense, hand over a style guide and hope for the best. It was a full operational and creative challenge spanning discovery, system building, execution and embedding.
            </p>
          </div>
        </div>

        <aside className="col-span-5 border-l border-ink/10 pl-12" data-id="element-43" data-mp="afbyc8dp4z52">
          <h3 className="font-display text-sm font-semibold uppercase tracking-[0.22em] text-ink/50" data-id="element-44" data-mp="feoq97jfcwei">
            Starting conditions
          </h3>
          <ul className="mt-8 space-y-7" data-id="element-45" data-mp="3dxn9t7x4sfje">
            {[{
            value: '100 → 500+',
            label: 'Employee growth design had to keep pace with'
          }, {
            value: 'One identity',
            label: 'xDesign became CreateFuture, a full name change, not a refresh'
          }, {
            value: 'Zero structure',
            label: 'No shared vision, no career framework, no consistent quality'
          }].map(item => <li key={item.value} data-id="element-46" data-mp="2v5kmxetwc30p">
                <p className="font-display text-[40px] font-bold leading-none tracking-tightest text-ink" data-id="element-47" data-mp="304nsr1hpad9q">
                  {item.value}
                </p>
                <p className="mt-3 text-sm leading-snug text-ink/60" data-id="element-48" data-mp="2s2oh4ll1bbg6">{item.label}</p>
              </li>)}
          </ul>
        </aside>
      </div>
    </SectionShell>;
}